// store/auth.js - Authentication store module
import { authApi } from '../services/api'

const state = {
  accessToken: null,
  user: null,
  loading: false
}

const getters = {
  isAuthenticated: state => !!state.accessToken && !!state.user,
  user: state => state.user,
  isAdmin: state => state.user?.role === 'admin',
  accessToken: state => state.accessToken
}

const mutations = {
  SET_AUTH(state, { accessToken, user }) {
    state.accessToken = accessToken
    state.user = user
  },
  SET_USER(state, user) {
    state.user = user
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  CLEAR_AUTH(state) {
    state.accessToken = null
    state.user = null
  }
}

const actions = {
  async login({ commit }, { email, password }) {
    commit('SET_LOADING', true)
    try {
      const data = await authApi.login(email, password)
      commit('SET_AUTH', { accessToken: data.accessToken, user: data.user })
      return data.user
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async logout({ commit }) {
    try {
      await authApi.logout()
    } catch (err) {
      // Ignore errors on logout
    } finally {
      commit('CLEAR_AUTH')
    }
  },

  async tryRestoreSession({ commit }) {
    try {
      const data = await authApi.refresh()
      if (data && data.accessToken) {
        commit('SET_AUTH', { accessToken: data.accessToken, user: data.user })
        return true
      }
    } catch (err) {
      // Session restore failed
    }
    return false
  },

  async changePassword({ commit }, { currentPassword, newPassword }) {
    const data = await authApi.changePassword(currentPassword, newPassword)
    if (data.accessToken) {
      commit('SET_AUTH', { accessToken: data.accessToken, user: data.user })
    }
    return data
  },

  async fetchCurrentUser({ commit }) {
    const user = await authApi.me()
    commit('SET_USER', user)
    return user
  },

  setAccessToken({ commit, state }, accessToken) {
    commit('SET_AUTH', { accessToken, user: state.user })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
